const INPUT_SELECTOR = 'select[multiple].select2-fw';

const OPTION_DEFAULTS = {
    closeOnSelect: false,
    minimumResultsForSearch: 7,
    placeholder: '',
    width: '100%',
    templateSelection: function(tag, container) {
        /**
         * For each `option` in the select, if it has the locked attribute, add a `.locked` class to the tag.
         * This allows us to ignore unsetting these values.
         */
        if (tag.element?.hasAttribute('locked')) {
            $(container).addClass('locked');
            tag.locked = true;
        }

        if (tag.element?.hasAttribute('invalid')) {
            $(container).addClass('invalid');
            tag.invalid = true;
        }

        return tag.text;
    },
};

const SelectMultiInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            const $input = $(this);
            const options = Object.assign({}, OPTION_DEFAULTS);

            // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
            const $modal = $input.closest('.modal');

            if ($modal.length) {
                options.dropdownParent = $modal.find('.modal-body')
                    || $modal.find('.modal-content')
                    || $modal;
            }

            if ($input.attr('placeholder')) {
                options.placeholder = $input.attr('placeholder');
            }

            $input
                .select2(options)
                .on('select2:unselecting', function(e) {
                    if (e?.params?.args?.data?.element?.hasAttribute('locked') ?? false) {
                        e.preventDefault();
                    }

                    if (e?.params?.args?.data?.element?.hasAttribute('invalid') ?? false) {
                        /** @type {HTMLOptionElement} el */
                        const el = e?.params?.args?.data?.element;

                        el.remove();
                    }
                })
                .on('select2:select', function(e) {
                    const $current = $(e.currentTarget);

                    const nullableEntry = $current.find('option[value=""]');

                    if (nullableEntry.length && e.params.data.id !== '') {
                        // Make sure that the nullable entry is unselected because something else was selected
                        nullableEntry
                            .prop('selected', false)
                            .trigger('change');
                    }

                    const $searchField = $('.select2-search__field');
                    if ($searchField) {
                        $searchField.val('');
                    }
                });
        });
    },
    destroy: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function() {
            const $input = $(this);
            $input.select2('destroy');
        });
    },
};

export default SelectMultiInput;
